import { reactive } from "@vue/runtime-core";

import theme from '@/styles/_theme.json';

type Viewport = {
  windowWidth: number
  windowHeight: number
  isMobile: boolean
  isDesktop: boolean
  isLandscape: boolean
  isTouch: boolean
}

// export const enum BREAKPOINTS {
//   MOBILE = theme.breakpoints.md + 'px',
//   TABLET = '800px',
//   DESKTOP = '1024px'
// }

export const Viewport = reactive<Viewport>({
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
  isMobile: false,
  isDesktop: false,
  isLandscape: false,
  isTouch: "ontouchstart" in window
}) as Viewport


Viewport.isMobile = isMobile();
Viewport.isDesktop = isDesktop();
Viewport.isLandscape = isLandscape();
Viewport.isTouch = isTouch();

function isMobile(){
  return Viewport.windowWidth < theme.breakpoints.md;
}

function isDesktop(){
  return Viewport.windowWidth >= theme.breakpoints.lg;
}

function isLandscape(){
  return Viewport.windowWidth > Viewport.windowHeight
}

function isTouch(){
  return "ontouchstart" in window
}

function onResize(){
  Viewport.windowWidth = window.innerWidth
  Viewport.windowHeight = window.innerHeight
  Viewport.isMobile = isMobile()
  Viewport.isDesktop = isDesktop()
  Viewport.isLandscape = isLandscape()

  calculateVH()
}


const calculateVH = () => {
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
}

export function initViewport(): void {
  window.addEventListener('resize', onResize);
  calculateVH()
}

export function disposeViewport(): void {
  window.removeEventListener('resize', onResize);
}